export default {
    loaded: "invite.loaded",
    resetAmount: "invite.reset.amount",
    toggleButton: "invite.toggle.button"
}